import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/Reveal";
import api from "@/lib/api";
import { IMAGES } from "@/lib/content";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);

  return (
    <>
      <Seo title="DC Nightlife Blog & Guides" description="Nightlife guides, happy hour tips and the best things to do in Washington DC — from ChiCha Lounge on U Street." path="/blog" image={IMAGES.dj} />
      <PageHero overline="Journal" title="The ChiCha Guide" subtitle="Nightlife guides, happy hour picks and the best things to do in DC." image={IMAGES.dj} />

      <section className="pb-28 bg-transparent">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          {posts.length === 0 ? (
            <p className="text-neutral-400 py-20 text-center">No posts yet.</p>
          ) : (
            <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => (
                <StaggerItem key={p.id}>
                  <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="card-lux group overflow-hidden flex flex-col h-full">
                    <div className="relative aspect-[16/10] overflow-hidden">
                      <img src={p.cover_image} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                      <div className="absolute inset-0 bg-gradient-to-t from-white/80 to-transparent" />
                    </div>
                    <div className="p-6 flex flex-col flex-1">
                      <div className="flex flex-wrap gap-2 mb-3">
                        {(p.tags || []).slice(0, 2).map((t) => <span key={t} className="text-[10px] uppercase tracking-widest text-neutral-900/70 border border-neutral-900/20 rounded-full px-2.5 py-1">{t}</span>)}
                      </div>
                      <h3 className="font-serif text-2xl text-neutral-900 group-hover:text-neutral-900 transition-colors leading-snug">{p.title}</h3>
                      <p className="text-neutral-500 text-sm mt-3 leading-relaxed flex-1">{p.excerpt}</p>
                      <span className="inline-flex items-center gap-1 text-neutral-900 text-sm mt-5">Read more <ArrowUpRight size={15} /></span>
                    </div>
                  </Link>
                </StaggerItem>
              ))}
            </Stagger>
          )}
        </div>
      </section>
    </>
  );
}
